import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Translate } from 'react-jhipster';
import { Form, Input, Button, Row, Col, Select, Breadcrumb, InputNumber, Switch } from 'antd';
import { getProfesseur, updateProfesseur, createProfesseur, reset, getRoles } from './personnel.reducer';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import 'antd/dist/antd.css';
import { getClasses } from '../classe/classe.reducer';
import { getEntities } from '../matiere-ecole/matiere-ecole.reducer';
import { getEcole } from '../ecole/ecole.reducer';
import { getPaymentMethodFromString } from 'app/utils/paymentUtils';

export const PersonnelUpdate = (props: RouteComponentProps<{ id: string; ecoleid: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const professeur = useAppSelector(state => state.professeur.entity);
  const classes = useAppSelector(state => state.classe.entities);
  const matieres = useAppSelector(state => state.matiereEcole.entities);
  const updateSuccess = useAppSelector(state => state.professeur.updateSuccess);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const [isChecked, setIsChecked] = useState(true);
  const [isActivated, setIsActivated] = useState(professeur.brs !== null ? professeur.brs : false);
  const [selectedClasses, setSelectedClasses] = useState([]);
  const [selectedMatieres, setSelectedMatieres] = useState([]);
  const [isPhoneChanged, setIsPhoneChanged] = useState(false);
  const [initialPhoneNumber, setInitialPhoneNumber] = useState(professeur.numeroTelephonePaiement || '');
  const [selectedType, setSelectedType] = useState(professeur.typePersonnel || '');

  const handleClose = event => {
    event.stopPropagation();
    props.history.push(`/personnel/${currentEcole && currentEcole.id}`);
  };
  const moyenPaiements = ['WAVE', 'OM', 'ESPECE_CHECK'];

  const handlePhoneNumberChange = (value: string) => {
    setIsPhoneChanged(value !== initialPhoneNumber);
    setInitialPhoneNumber(value);
  };

  useEffect(() => {
    dispatch(getEcole(props.match.params.ecoleid));
    dispatch(getClasses(props.match.params.ecoleid));
    dispatch(getEntities({ ecoleId: props.match.params.ecoleid, page: 0, size: 100 }));

    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getProfesseur(props.match.params.id));
      setSelectedClasses(professeur.classes.map(c => ({ id: c.id })));
      setSelectedMatieres(professeur.matieresEcole.map(c => ({ id: c.id })));
    }

    dispatch(getRoles());
    return () => {
      dispatch(reset());
    };
  }, [props.match.params.id]);

  useEffect(() => {
    if (updateSuccess) {
      handleClose(event);
    }
  }, [updateSuccess]);

  const hasUserAccount = [
    'SECRETAIRE',
    'COMPTABLE',
    'DIRECTEUR',
    'DIRECTEUR_ETUDE',
    'SURVEILLANT',
    'SURVEILLANT_GENERAL',
    'CONTROLEUR_BUS',
  ].includes(selectedType);

  const saveProfesseur = v => {
    const entityBase = {
      ...professeur,
      ...v,
      id: props.match.params.id,
      ecoleId: props.match.params.ecoleid,
      classes: selectedType === 'ENSEIGNANT' ? selectedClasses : [],
      matieresEcole: selectedType === 'ENSEIGNANT' ? selectedMatieres : [],
    };
    const entity = hasUserAccount
      ? {
          ...entityBase,
          login: v.login?.trim(),
          email: v.email?.trim(),
        }
      : {
          ...entityBase,
          login: undefined,
          email: undefined,
        };

    if (isNew) {
      dispatch(createProfesseur(entity));
    } else {
      dispatch(updateProfesseur(entity)).then(() => {
        dispatch(getProfesseur(props.match.params.id));
      });
      if (isPhoneChanged && initialPhoneNumber !== '') {
        props.history.push(`/personnel/${props.match.params.ecoleid}/${props.match.params.id}/verify-otp`);
      }
    }
  };

  const toggleSwitch = checked => {
    setIsChecked(!checked);
  };
  const toggleBRS = activated => {
    setIsActivated(activated);
  };

  const handleClasse = data => {
    setSelectedClasses(data.map(d => ({ id: d })));
  };

  const handleMatiere = data => {
    setSelectedMatieres(data.map(d => ({ id: d })));
  };
  return (
    <div>
      {isNew ? (
        <Breadcrumb className="p-2">
          <Breadcrumb.Item>
            <Link to={`/home/${currentEcole && currentEcole.id}`}>{currentEcole && currentEcole.nom}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/personnel/${currentEcole && currentEcole.id}`}>Personnel</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      ) : (
        <Breadcrumb className="p-2">
          <Breadcrumb.Item>
            <Link to={`/home/${currentEcole && currentEcole.id}`}>{currentEcole && currentEcole.nom}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`/personnel/${currentEcole && currentEcole.id}`}>Personnel</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={`personnel/${professeur.id}`}>Details</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      )}
      <Row className="justify-content-center">
        <Col span={12}>
          {isNew ? (
            <h2 id="korischoolApp.personnel.home.createOrEditLabel" data-cy="PersonnelCreateHeading">
              <Translate contentKey="korischoolApp.personnel.home.createLabel">Create a Personnel</Translate>
            </h2>
          ) : (
            <h2 id="korischoolApp.personnel.home.createOrEditLabel" data-cy="PersonnelCreateHeading">
              <Translate contentKey="korischoolApp.personnel.home.editLabel">Edit a Personnel</Translate>
            </h2>
          )}
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col span={18} offset={6}>
          <Form
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            layout="vertical"
            size="large"
            onFinish={saveProfesseur}
            initialValues={!isNew && professeur}
          >
            <Form.Item label="Type" name="typePersonnel" rules={[{ required: true, message: 'Veuillez sélectionner un type' }]}>
              <Select placeholder="Sélectionnez le type" onChange={value => setSelectedType(value)}>
                <Select.Option value="ENSEIGNANT">ENSEIGNANT</Select.Option>
                <Select.Option value="SECRETAIRE">SECRETAIRE</Select.Option>
                <Select.Option value="COMPTABLE">COMPTABLE</Select.Option>
                <Select.Option value="DIRECTEUR">DIRECTEUR</Select.Option>
                <Select.Option value="DIRECTEUR_ETUDE">DIRECTEUR D’ÉTUDE</Select.Option>
                <Select.Option value="SURVEILLANT">SURVEILLANT</Select.Option>
                <Select.Option value="SURVEILLANT_GENERAL">SURVEILLANT GÉNÉRAL</Select.Option>
                <Select.Option value="CONTROLEUR_BUS">CONTRÔLEUR BUS</Select.Option>
                <Select.Option value="PERSONNEL">AUTRE_PERSONNEL</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item label="Matricule" name="matricule" rules={[{ required: true }]}>
              <Input placeholder="matricule" />
            </Form.Item>
            <Form.Item label="Prénom" name="prenom" rules={[{ required: true }]}>
              <Input placeholder="Prenom" />
            </Form.Item>
            <Form.Item label="Nom" name="nom" rules={[{ required: true }]}>
              <Input placeholder="Nom" />
            </Form.Item>
            <Form.Item
              label="Téléphone"
              name="telephone"
              rules={[{ required: true, min: 0, max: 9, message: 'ce champs doit contenir au maximum 9 chiffres' }]}
            >
              <Input placeholder="Téléphone" />
            </Form.Item>
            {['SECRETAIRE', 'COMPTABLE', 'DIRECTEUR', 'DIRECTEUR_ETUDE', 'SURVEILLANT', 'SURVEILLANT_GENERAL', 'CONTROLEUR_BUS'].includes(
              selectedType
            ) && (
              <>
                <Form.Item
                  label="Login"
                  name="login"
                  rules={[{ required: true, message: 'Login requis' }]}
                  extra="ex: prenom.nom (ou tout identifiant unique)"
                >
                  <Input placeholder="prenom.nom" />
                </Form.Item>

                <Form.Item label="E-mail" name="email" rules={[{ required: true, type: 'email', message: 'saisir un e-mail valide' }]}>
                  <Input placeholder="E-mail" />
                </Form.Item>
              </>
            )}
            {isNew && (selectedType === 'SURVEILLANT' || selectedType === 'CONTROLEUR_BUS') && (
              <>
                <Form.Item label="Mot de passe" name="password">
                  <Input.Password placeholder="Mot de passe" />
                </Form.Item>
                <Form.Item
                  label="Confirmez mot de passe"
                  name="confirmPassword"
                  dependencies={['password']}
                  rules={[
                    { required: true, message: 'SVP confirmez votre mot de passe!' },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue('password') === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(new Error('Mot de passe non identique'));
                      },
                    }),
                  ]}
                >
                  <Input.Password placeholder="Confirmez mot de passe" />
                </Form.Item>
              </>
            )}

            <Form.Item label="Poste" name="poste" rules={[{ required: true, message: 'Veuillez saisir le poste' }]}>
              <Input placeholder="Ex: Surveillant, Comptable, Professeur de Maths..." />
            </Form.Item>
            {selectedType === 'ENSEIGNANT' && (
              <>
                <Form.Item label="Classe">
                  <Select
                    placeholder="Classe"
                    style={{ width: '100%' }}
                    mode="multiple"
                    defaultValue={isNew ? [] : professeur.classes.map(c => c.id)}
                    onChange={handleClasse}
                    allowClear
                  >
                    {classes.map((classe, i) => (
                      <Select.Option key={classe.id} value={classe.id}>
                        {classe.nom}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item label="Matière">
                  <Select
                    placeholder="Matière"
                    style={{ width: '100%' }}
                    mode="multiple"
                    allowClear
                    onChange={handleMatiere}
                    defaultValue={isNew ? [] : professeur.matieresEcole.map(m => m.id)}
                  >
                    {matieres.map((matiere, i) => (
                      <Select.Option key={i} value={matiere.id}>
                        {matiere.nom}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </>
            )}
            {selectedType !== 'DIRECTEUR' && selectedType !== 'DIRECTEUR_ETUDE' && (
              <>
                <Form.Item label="Activer la Retenue BRS" name="brs" valuePropName="checked">
                  <Switch checked={isActivated} onChange={toggleBRS} style={{ marginLeft: 5 }} />
                </Form.Item>
                {isChecked ? (
                  <Form.Item label="Salaire Mensuel" name="salaireMensuel" rules={[{ type: 'number' }]} style={{ marginBottom: 8 }}>
                    <InputNumber name="salaireMensuel" min={0} style={{ width: '100%' }} controls={false} />
                  </Form.Item>
                ) : (
                  <Form.Item label="Taux Horaire" name="tauxHoraire" rules={[{ type: 'number' }]} style={{ marginBottom: 8 }}>
                    <InputNumber name="tauxHoraire" min={0} style={{ width: '100%' }} controls={false} />
                  </Form.Item>
                )}
                <Form.Item>
                  <Row align="middle">
                    <Col>
                      <span>Passer au {isChecked ? 'taux horaire' : 'salaire mensuel'}</span>
                    </Col>
                    <Col>
                      <Switch checked={!isChecked} onChange={toggleSwitch} style={{ marginLeft: 8 }} size="small" />
                    </Col>
                  </Row>
                </Form.Item>
                <Form.Item label="Préference de Paiement" name="moyenPaiement" rules={[{ required: true }]}>
                  <Select placeholder="Moyen de Paiment du salaire" style={{ width: '100%' }} optionFilterProp="children">
                    {moyenPaiements.map((moyen, i) => (
                      <Select.Option key={i} value={moyen}>
                        {getPaymentMethodFromString(moyen)}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label="Numéro de Téléphone de Paiement"
                  name="numeroTelephonePaiement"
                  rules={[{ required: true, min: 9, max: 9, message: 'ce champs doit contenir au maximum 9 chiffres' }]}
                >
                  <Input placeholder="Téléphone" onChange={e => handlePhoneNumberChange(e.target.value)} />
                </Form.Item>
              </>
            )}

            <Form.Item label="Adresse" name="adresse" rules={[{ required: true }]}>
              <Input.TextArea placeholder="Adresse" />
            </Form.Item>
            <Form.Item>
              <Button
                style={{ backgroundColor: '#F28E19', color: 'white' }}
                data-cy="entityCreateSaveButton"
                htmlType="submit"
                id="save-entity"
              >
                Enregistrer
              </Button>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default PersonnelUpdate;
